import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { withErrorBoundary } from '../errors/ErrorBoundary'

import copy from 'copy-to-clipboard'
import Location from '../components/Location'

const styles = theme => ({
  container: {
    position: 'absolute',
    bottom: '0px',
    left: '100px',
    // backgroundColor: 'lightGray',
    zIndex: 3001
  }
})

class LocationContainer extends PureComponent {
  handleClick = (event, value) => {
    console.log(event.target)
    console.log(value)
    copy(event.target.textContent)
  }

  render () {
    const { classes, bounds, center, render, mouse, zoom } = this.props

    if (!render) {
      return null
    }

    return (
      <div className={classes.container}>
        <Location
          bounds={bounds}
          center={center}
          mouse={mouse}
          handleClick={this.handleClick}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    bounds: state.map.bounds,
    center: state.map.toggleCenter,
    render: state.service.coordinatesOpen,
    mouse: state.mouse.lngLat,
    zoom: state.map.zoom
  }
}

export default withErrorBoundary(connect(mapStateToProps, null)(
  withStyles(styles)(LocationContainer)
))



// WEBPACK FOOTER //
// ./src/containers/LocationContainer.js